// Utility to suppress specific deprecation warnings
export const suppressQuillDeprecationWarnings = () => {
  // Store original console.warn
  const originalWarn = console.warn;

  // Override console.warn to filter out Quill.js deprecation warnings
  console.warn = (...args) => {
    const message = args.join(" ");

    // Suppress Quill.js DOMNodeInserted deprecation warning
    if (message.includes("DOMNodeInserted") && message.includes("quill")) {
      return; // Don't log this specific warning
    }

    // Log all other warnings normally
    originalWarn.apply(console, args);
  };

  // Return function to restore original console.warn
  return () => {
    console.warn = originalWarn;
  };
};
